import React from 'react';
import { Modal, ModalHeader, ModalBody, Table } from 'reactstrap';
import Loader from '../../common/Loader';
import Draggable from 'react-draggable';
import PropTypes from 'prop-types';

const AudienceCompareModal = ({ isOpen, toggle, compareData, isLoading, subscriptions }) => {

  const hasFeature = (feature) => {
    const audienceSubscription = subscriptions?.find(sub => sub.subscriptionType === "AUDIENCE");
    return audienceSubscription?.featureFlags?.[feature] === true;
  };

  return (
    <Draggable handle=".modal-header">
      <Modal isOpen={isOpen} toggle={toggle} className="modal-dialog modal-fullscreen">
        <ModalHeader toggle={toggle}>Compare Audience</ModalHeader>
        <ModalBody>
          <Table striped bordered>
            <thead>
              <tr>
                <th>Feature / Audience Name</th>
                {compareData?.map((data, index) => (
                  <th key={index} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    {data.fullData.name || '-'}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Audience Size</strong></td>
                {compareData?.map((data, index) => (
                  <td key={index}>
                    <strong>{data.fullData.audienceSize ? data.fullData.audienceSize.toLocaleString() : '-'}</strong>
                  </td>
                ))}
              </tr>

              <tr>
                <td><strong>Generation Ratios</strong></td>
                {compareData?.map((data, index) => (
                  <td key={index}>
                    <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                      <li>Alpha: <strong>{data.fullData.generation?.alphaRatio ? data.fullData.generation.alphaRatio + '%' : '-'}</strong></li>
                      <li>Baby Boomer: <strong>{data.fullData.generation?.babyBoomerRatio ? data.fullData.generation.babyBoomerRatio + '%' : '-'}</strong></li>
                      <li>Gen X: <strong>{data.fullData.generation?.xratio ? data.fullData.generation.xratio + '%' : '-'}</strong></li>
                      <li>Gen Y: <strong>{data.fullData.generation?.yratio ? data.fullData.generation.yratio + '%' : '-'}</strong></li>
                      <li>Gen Z: <strong>{data.fullData.generation?.zratio ? data.fullData.generation.zratio + '%' : '-'}</strong></li>
                    </ul>
                  </td>
                ))}
              </tr>

              <tr>
                <td><strong>Top Locations</strong></td>
                {compareData?.map((data, index) => (
                  <td key={index}>
                    <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                      {data.fullData.locations?.locations?.length > 0 ? (
                        data.fullData.locations.locations.map((location, locIndex) => (
                          <li key={locIndex}>
                            {location.name} : <strong>{parseFloat(location.ratio).toFixed(1)}%</strong>
                          </li>
                        ))
                      ) : (
                        <li>-</li>
                      )}
                    </ul>
                  </td>
                ))}
              </tr>

              <tr>
                <td><strong>Purchasing Power</strong></td>
                {compareData?.map((data, index) => (
                  <td key={index}>
                    <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                      {data.fullData.purchasing ? (
                        <>
                          <li>Very High: <strong>{data.fullData.purchasing.veryHighRatio ? data.fullData.purchasing.veryHighRatio + '%' : '-'}</strong></li>
                          <li>High: <strong>{data.fullData.purchasing.highRatio ? data.fullData.purchasing.highRatio + '%' : '-'}</strong></li>
                          <li>Moderate: <strong>{data.fullData.purchasing.moderateRatio ? data.fullData.purchasing.moderateRatio + '%' : '-'}</strong></li>
                          <li>Low: <strong>{data.fullData.purchasing.lowRatio ? data.fullData.purchasing.lowRatio + '%' : '-'}</strong></li>
                          <li>Very Low: <strong>{data.fullData.purchasing.veryLowRatio ? data.fullData.purchasing.veryLowRatio + '%' : '-'}</strong></li>
                        </>
                      ) : (
                        <li>-</li>
                      )}
                    </ul>
                  </td>
                ))}
              </tr>


              {hasFeature("analytic::sales_prediction") && (
              <tr>
                <th scope="row">Sales Prediction</th>
                {compareData?.map((data, index) => {               
                  return (
                    <td key={index}>
                      {data?.fullData?.sales?.predictions?.length > 0 ? (
                        <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                          {data.fullData.sales.predictions.map((prediction, idx) => (
                            <li key={idx}>
                              {prediction.name}: <strong>{parseFloat(prediction.probability).toFixed(1)}%</strong>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        "-"
                      )}
                    </td>
                  );
                })}
              </tr>
              )}

              <tr>
                <td><strong>Gender Ratios</strong></td>
                {compareData?.map((data, index) => (
                  <td key={index}>
                    <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                      {data.fullData.gender ? (
                        <>
                          <li>Male: <strong>{data.fullData.gender.maleRatio ? data.fullData.gender.maleRatio + '%' : '-'}</strong></li>
                          <li>Female: <strong>{data.fullData.gender.femaleRatio ? data.fullData.gender.femaleRatio + '%' : '-'}</strong></li>
                        </>
                      ) : (
                        <li>-</li>
                      )}
                    </ul>
                  </td>
                ))}
              </tr>

              <tr>
                <td><strong>Top Profile Types</strong></td>
                {compareData?.map((data, index) => (
                  <td key={index}>
                    <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                      {data.fullData.topProfileTypes?.length > 0 ? (
                        data.fullData.topProfileTypes.map((type, typeIndex) => (
                          <li key={typeIndex}>{type.profileName}</li>
                        ))
                      ) : (
                        <li>-</li>
                      )}
                    </ul>
                  </td>
                ))}
              </tr>

              <tr>
                <td><strong>Analysis Insights</strong></td>
                {compareData?.map((data, index) => (
                  <td key={index}>
                    {data.fullData.analysis ? (
                      <p>{data.fullData.analysis.message}</p>
                    ) : (
                      <p>-</p>
                    )}
                  </td>
                ))}
              </tr>
            </tbody>
          </Table>
        </ModalBody>
      </Modal>
    </Draggable>
  );
};

AudienceCompareModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  compareData: PropTypes.array,
  isLoading: PropTypes.bool,
  subscriptions: PropTypes.array,
};

export default AudienceCompareModal;
